<template>
  <v-row>
    <v-col>
      <v-card rounded="xl" class="mb-6 pb-9" outlined>
        <v-card-title class="pt-9"
          >Sipariş Verilen Ürünler <v-spacer /><v-chip
            color="secondary"
            label
            class="text-overline"
            >{{ callCenterStore.sumProductsPrice | currency }}</v-chip
          >
        </v-card-title>
        <v-card-subtitle>
          <div class="text-caption mb-1">
            Ürün :
            <b class="white--text">{{ callCenterStore.totalProducts }} Adet</b> | Paket :
            <b class="white--text">{{ callCenterStore.packageProducts }} Adet</b>
          </div></v-card-subtitle
        >

        <v-data-table :headers="headers" :items="items" :items-per-page="-1" hide-default-footer>
          <template v-slot:item.baslik="{ item }">
            <div class="text-body-2">
              {{ item.baslik }}
            </div>
            <div class="text-caption" v-html="item.altBaslik"></div>
          </template>
          <template v-slot:item.quantity="{ item }">
            <div class="text-caption">{{ item.quantity }}</div>
          </template>
          <template v-slot:item.birim="{ item }">
            <div class="text-caption">
              {{ item.birim }}
            </div>
          </template>
          <template v-slot:item.satis_fiyati="{ item }">
            <div class="text-caption">{{ item.satis_fiyati | currency }}</div>
          </template>
          <template v-slot:item.ara_toplam="{ item }">
            <div class="text-caption">{{ (item.quantity * item.satis_fiyati) | currency }}</div>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { computed, ref } from "@vue/composition-api";

// Store
import { useCallCenterStore } from "@/stores/callCenter";

export default {
  setup() {
    const callCenterStore = useCallCenterStore();

    const headers = ref([
      {
        text: "Başlık",
        value: "baslik",
        sortable: false,
      },
      {
        text: "Miktar",
        value: "quantity",
        align: "right",
        width: "90px",
        sortable: false,
      },
      {
        text: "Birim",
        value: "birim",
        width: "90px",
        sortable: false,
      },
      {
        text: "Birim Fiyat",
        value: "satis_fiyati",
        width: "150px",
        align: "right",
        sortable: false,
      },
      {
        text: "Ara Toplam",
        value: "ara_toplam",
        width: "150px",
        align: "right",
        sortable: false,
      },
    ]);

    const items = computed(() => {
      return callCenterStore.data.products;
    });

    return {
      callCenterStore,
      items,
      headers,
    };
  },
};
</script>

<style></style>
